import React from "react";
import WhatsAppButton from "../WhatsAppButton";

const Header = () => {
  return (
    <div
      style={{
        backgroundColor: "black",
        padding: "6px",
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        zIndex: 1000,
        color: "white",
        display: "flex",
        justifyContent: "flex-end",
        alignItems: "center",
      }}
    >
      <span
        style={{
          fontSize: "15px",
          paddingRight: "10px",
          border: "none",
          backgroundColor: "black",
          color: "white",
        }}
      >
        <WhatsAppButton />
      </span>
    </div>
  );
};

export default Header;
